"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _PollEditor = _interopRequireDefault(require("../PollEditor"));

var _PollResults = _interopRequireDefault(require("../PollResults"));

var _consts = require("../consts");

var _Header = _interopRequireDefault(require("./Header"));

var _Footer = _interopRequireDefault(require("./Footer"));

var _styles = require("./styles");

function PollContent(props) {
  var Content = props.poll.status === _consts.PollStatus.DRAFT ? _PollEditor.default : _PollResults.default;
  return _react.default.createElement("div", {
    className: (0, _classnames.default)(_styles.pollContent, 'poll-content')
  }, _react.default.createElement(_Header.default, props), _react.default.createElement(Content, props), _react.default.createElement(_Footer.default, props));
}

var _default = PollContent;
exports.default = _default;